"use strict";

require("core-js/modules/es.object.values");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;
exports.icons = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icons = {
  DOWNLOAD: 'download',
  MONITOR: 'monitor',
  PHONE: 'phone',
  EMAIL: 'email'
};
/**
 *
 * @param {string} iconName
 * @returns {XML}
 */

exports.icons = icons;

function getIconFromIconName(iconName) {
  switch (iconName) {
    case icons.DOWNLOAD:
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 12 12",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(-116.000000, -18.000000)",
        fill: "currentColor"
      }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(116.000000, 18.000000)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.3084244,9.25794358 L10.3084244,10.1543079 C10.3084244,10.6373982 9.91529856,11.0300554 9.43267687,11.0300554 L1.812877,11.0300554 C1.33025531,11.0300554 0.937129489,10.6373982 0.937129489,10.1543079 L0.937129489,9.25794358 C0.937129489,8.99929584 0.727681048,8.78937883 0.468564745,8.78937883 C0.209448441,8.78937883 0,8.99929584 0,9.25794358 L0,10.1543079 C0,11.1537565 0.812959832,11.9671849 1.812877,11.9671849 L9.43267687,11.9671849 C10.432594,11.9671849 11.2455539,11.1537565 11.2455539,10.1543079 L11.2455539,9.25794358 C11.2455539,8.99929584 11.0361054,8.78937883 10.7769891,8.78937883 C10.5178728,8.78937883 10.3084244,8.99929584 10.3084244,9.25794358 Z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.674099,4.0791841 L5.15421219,1.5990709 L5.15421219,8.48416126 C5.15421219,8.74327756 5.36366063,8.95272601 5.62277693,8.95272601 C5.88189324,8.95272601 6.09134168,8.74327756 6.09134168,8.48416126 L6.09134168,1.5990709 L8.57145487,4.0791841 C8.662825,4.17055422 8.78277757,4.21647357 8.90273015,4.21647357 C9.02268272,4.21647357 9.1426353,4.17055422 9.23400542,4.0791841 C9.41721424,3.89597528 9.41721424,3.59984236 9.23400542,3.41663355 L5.95452077,0.137148901 C5.91094425,0.0935723795 5.85940213,0.0593671531 5.80176867,0.0354703512 C5.68743887,-0.011854688 5.558115,-0.011854688 5.4437852,0.0354703512 C5.38615174,0.0593671531 5.33460962,0.0935723795 5.2910331,0.137148901 L2.01154845,3.41663355 C1.82833963,3.59984236 1.82833963,3.89597528 2.01154845,4.0791841 C2.19475726,4.26239291 2.49089018,4.26239291 2.674099,4.0791841",
        transform: "translate(5.622777, 4.476351) rotate(180.000000) translate(-5.622777, -4.476351) "
      }))))));

    case icons.MONITOR:
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: "40px",
        height: "34px",
        viewBox: "0 0 40 34",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(-136.000000, -806.000000)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(121.000000, 788.000000)"
      }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(15.000000, 18.000000)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M32.5,32.4983333 L7.5,32.4983333 C10.4016667,30.9766667 15.0033333,30 20,30 C24.9966667,30 29.5983333,30.9766667 32.5,32.4983333 Z",
        id: "Stroke-1",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M39.1666667,24.1666667 C39.1666667,25.0833333 38.4183333,25.8333333 37.5,25.8333333 L2.5,25.8333333 C1.58333333,25.8333333 0.833333333,25.0833333 0.833333333,24.1666667 L0.833333333,2.5 C0.833333333,1.58333333 1.58333333,0.833333333 2.5,0.833333333 L37.5,0.833333333 C38.4183333,0.833333333 39.1666667,1.58333333 39.1666667,2.5 L39.1666667,24.1666667 Z",
        id: "Stroke-3",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("polygon", {
        id: "Stroke-5",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        mask: "url(#mask-2)",
        points: "4.16666667 22.5 35.8333333 22.5 35.8333333 4.16666667 4.16666667 4.16666667"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.5,25.8333333 L17.5,30.0816667",
        id: "Stroke-7",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        mask: "url(#mask-2)"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22.5,25.8333333 L22.5,30.0816667",
        id: "Stroke-8",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        mask: "url(#mask-2)"
      }))))));

    case icons.EMAIL:
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: "40px",
        height: "27px",
        viewBox: "0 0 40 27",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(-943.000000, -810.000000)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(928.000000, 788.000000)",
        fill: "currentColor"
      }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(15.000000, 22.000000)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M35.9993338,26.2295082 L4.00066602,26.2295082 C1.79386135,26.2295082 0,24.5206459 0,22.4228095 L0,3.80669859 C0,1.70667716 1.79386135,0 4.00066602,0 L35.9993338,0 C38.2061387,0 40,1.70667716 40,3.80669859 L40,22.4228095 C40,24.5206459 38.2061387,26.2295082 35.9993338,26.2295082 Z M4.00066602,23.6924375 L35.9993338,23.6924375 C36.7364155,23.6924375 37.3336293,23.1220882 37.3336293,22.4228095 L37.3336293,4.07766911 L20.8336572,16.645019 C20.5894433,16.8285797 20.2941666,16.9225454 20.00111,16.9225454 C19.7058334,16.9225454 19.4105567,16.8285797 19.1663429,16.645019 L2.66637066,4.07766911 L2.66637066,22.4228095 C2.66637066,23.1220882 3.26580451,23.6924375 4.00066602,23.6924375 Z M35.0868624,2.53707064 L4.91313759,2.53707064 L20.00111,14.0270943 L35.0868624,2.53707064 Z"
      }))))));

    case icons.PHONE:
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: "38px",
        height: "40px",
        viewBox: "0 0 38 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(-540.000000, -805.000000)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(524.000000, 790.000000)",
        fill: "currentColor"
      }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(16.000000, 15.000000)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M29.08113,40 C27.821204,40 26.5542318,39.6179225 25.4474835,38.8301412 C15.8557073,32.017284 7.43251413,22.9701603 1.08842956,12.6685707 C-0.632609587,9.87284132 -0.28184249,6.12326357 1.92234481,3.75640789 L4.07400672,1.44464947 C5.86700138,-0.481884295 8.99106621,-0.480698427 10.7824381,1.44309872 L14.7107819,5.66209775 C16.5592912,7.64801614 16.5592912,10.8785942 14.7115933,12.8645126 L14.7107819,12.8661089 L14.0713814,13.5507653 C17.2360147,17.6025569 20.8573198,21.4925688 24.6253544,24.8888035 L25.2639436,24.2017754 C26.1602914,23.2396716 27.3515074,22.7100447 28.6184795,22.7100447 L28.6214688,22.7100447 C29.8878858,22.7100447 31.0781623,23.2396716 31.9723323,24.2033262 L35.8981139,28.4195886 C36.7939493,29.3816924 37.2879441,30.6605142 37.2879441,32.020796 C37.2879441,33.3822637 36.7939493,34.6615416 35.8981139,35.6235998 L33.744146,37.9369546 C32.4780279,39.2984223 30.7858564,40 29.08113,40 Z M7.42871352,2.18837114 C6.74707919,2.18837114 6.06467619,2.46732378 5.54582785,3.02490979 L3.39403783,5.33666821 C1.88557704,6.9570656 1.6457111,9.52223488 2.82428684,11.4357697 C9.01536454,21.4890568 17.2353314,30.316202 26.5948429,36.9665953 C28.3786136,38.2324638 30.7655295,37.9759058 32.2724956,36.3570592 L34.4272749,34.0421536 C34.9299386,33.5030854 35.2064869,32.7849511 35.2064869,32.020796 C35.2064869,31.2570514 34.9299386,30.540103 34.4272749,30.0010348 L30.5006392,25.7835865 C29.9979756,25.242557 29.3304761,24.9439007 28.6201023,24.9439007 L28.6184795,24.9439007 C27.9072516,24.9439007 27.2389835,25.2413712 26.7347825,25.7835865 L25.4264306,27.1883384 C25.0488884,27.594042 24.4456151,27.6262885 24.0313051,27.2623183 C19.657435,23.4135837 15.4485715,18.8939672 11.8602762,14.1898113 C11.521039,13.744381 11.5515721,13.0966691 11.9297976,12.6898251 L13.239943,11.2850733 C14.2761023,10.1699012 14.2769137,8.35670909 13.239943,7.24390882 L9.31155648,3.02490979 C8.79245192,2.46732378 8.11030515,2.18837114 7.42871352,2.18837114 Z M13.9752984,12.0751806 L13.9908852,12.0751806 L13.9752984,12.0751806 Z"
      }))))));

    default:
      return null;
  }
}

function Icon(_ref) {
  var iconName = _ref.iconName;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "svg-icon ".concat(iconName)
  }, getIconFromIconName(iconName));
}

Icon.defaultProps = {};
Icon.propTypes = {
  iconName: _propTypes.default.oneOf(Object.values(icons)).isRequired
};
//# sourceMappingURL=Icon.js.map